import React from 'react'
import { getNameCellRenderer } from './name-cell'
import { LibraryAgentLanguage } from '../library/library-agent-language'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { getFirstSeenCellRenderer } from './first-seen-cell'
import { getLastSeenCellRenderer } from './last-seen-cell'
import { FormattedMessage } from 'react-intl'
import { Library } from '../../helpers/ui-interfaces'

const agentLanguageTranslationMap = new Map([
  [
    LibraryAgentLanguage.JAVA,
    {
      placeholder: 'placeholder_libraryUsage_findClass',
      columnHeader: 'title_libraryUsage_classesLoaded'
    }
  ],
  [
    LibraryAgentLanguage.NODE,
    {
      placeholder: 'placeholder_libraryUsage_findFile',
      columnHeader: 'title_libraryUsage_filesLoaded'
    }
  ],
  [
    LibraryAgentLanguage.PYTHON,
    {
      placeholder: 'placeholder_libraryUsage_findFile',
      columnHeader: 'title_libraryUsage_filesLoaded'
    }
  ],
  [
    LibraryAgentLanguage.RUBY,
    {
      placeholder: 'placeholder_libraryUsage_findFile',
      columnHeader: 'title_libraryUsage_filesLoaded'
    }
  ],
  [
    LibraryAgentLanguage.DOTNET,
    {
      placeholder: 'placeholder_libraryUsage_findClass',
      columnHeader: 'title_libraryUsage_classesLoaded'
    }
  ],
  [
    LibraryAgentLanguage.GO,
    {
      placeholder: 'placeholder_libraryUsage_findFunction',
      columnHeader: 'title_libraryUsage_functionsLoaded'
    }
  ]
])

export const getColumns = ({
  library,
  language,
  tableWidth,
  usedClassesCount
}: {
  library: Library
  language: LibraryAgentLanguage
  tableWidth: number
  usedClassesCount: number
}) => {
  const agentLanguageTranslations = agentLanguageTranslationMap.get(language)

  return [
    {
      accessorKey: 'name',
      enableSorting: true,
      cell: ({
        row: {
          original: { name }
        }
      }) =>
        getNameCellRenderer({
          name,
          tableWidth
        }),
      header: () => (
        <>
          {agentLanguageTranslations && (
            <div
              className={css`
                font: ${theme.font.bodyStrong.font};
              `}
              data-e2e={`column-header-${agentLanguageTranslations.columnHeader}`}
            >
              <FormattedMessage id={agentLanguageTranslations.columnHeader} />
              &nbsp; ({usedClassesCount}/{library.usage.total})
            </div>
          )}
        </>
      )
    },
    {
      accessorKey: 'firstObservedTime',
      enableSorting: true,
      cell: ({
        row: {
          original: { firstObservedTime }
        }
      }) => getFirstSeenCellRenderer({ firstObservedTime }),
      header: () => <FormattedMessage id="title_libraryUsage_firstSeen" />
    },
    {
      accessorKey: 'lastObservedTime',
      enableSorting: true,
      cell: ({
        row: {
          original: { lastObservedTime }
        }
      }) => getLastSeenCellRenderer({ lastObservedTime }),
      header: () => <FormattedMessage id="title_libraryUsage_lastSeen" />
    }
  ]
}
